import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import PasswordInput from "@/components/PasswordInput";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl bg-white border border-slate-200 p-8 card-glow" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-1">
          <ShieldCheck className="w-4 h-4 text-[#D91E2A]" />
          <span className="text-xs font-mono-fin uppercase tracking-[0.3em] text-[#D91E2A]">Editor Console</span>
        </div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tight text-slate-900 mb-6">Admin Login</h1>

        <div className="space-y-4">
          <div>
            <Label className="text-xs font-mono-fin uppercase tracking-widest text-slate-500">Email</Label>
            <Input value={email} onChange={e => setEmail(e.target.value)} type="email" autoComplete="email" className="mt-1.5 bg-slate-50 border-slate-200 font-mono-fin" placeholder="you@example.com" data-testid="admin-email-input" />
          </div>
          <div>
            <Label className="text-xs font-mono-fin uppercase tracking-widest text-slate-500">Password</Label>
            <PasswordInput value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" testid="admin-password-input" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-[#D91E2A] hover:bg-[#B01820] text-white font-semibold" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Enter Terminal"}
          </Button>
        </div>
        <p className="text-[11px] text-slate-500 mt-6 font-mono-fin">Access restricted to authorised editors.</p>
      </form>
    </div>
  );
}
